import { gql } from "graphql-request";

export const GET_USER_EMAIL_RECOVERY = gql`
query GetUserEmailRecovery($rut: Float!) {
  getUserEmailRecovery(rut: $rut) {
    rut
    email
  }
}
`;

export const GET_USER_CAN_RECOVER_PASSWORD = gql`
query GetUserCanRecoverPassword($rut: Float!, $captchaToken: String) {
  getUserCanRecoverPassword: getUserCanRecoverPasswordV2(rut: $rut, captchaToken: $captchaToken) {
    rut
    email
    recoveryFlow
  }
}
`;

export const GET_USER_CAN_RECOVER_PASSWORD_V1 = gql`
query GetUserCanRecoverPasswordV1($rut: Float!) {
  getUserCanRecoverPassword: getUserCanRecoverPassword(rut: $rut) {
    rut
    email
    recoveryFlow
  }
}
`;
